import React from 'react';
import { useParams, useLocation } from 'react-router-dom';

const withRouter = WrappedComponent => props => {
  const params = useParams();
  const state = useLocation();

  return (
    <WrappedComponent
      {...props}
      params={params}
      {...state}
    />
  );
};

export default withRouter;